import { StudentProblemResult } from '@yandex-int/k-common/typings';
import React from 'react';

import { EmptyAttempts } from '../_student-attempts-value/empty-attempts';
import { InfinityAttempts } from '../_student-attempts-value/infinity-attempts';

export const CustomFlowLessonAttemptsText = (props: { studentProblemResult: StudentProblemResult | null }) => {
    const { studentProblemResult } = props;

    if (!studentProblemResult) {
        return <EmptyAttempts />;
    }

    return <InfinityAttempts studentProblemResult={studentProblemResult} />;
};
